import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/warehouse/reception',
}).lazy(() => import('./reception.lazy').then((d) => d.Route))
